import {PredictionWidgetCardsModel} from "./prediction-widget.cards.model";
import {override} from "mobx";

export class PredictionWidgetMainCardsModel extends PredictionWidgetCardsModel {
  @override get isPlayerBet(): Boolean {
    return false;
  }

  @override get hasIcon(): Boolean {
    return false
  }

  @override get iconSource(): Boolean {
    return null;
  }
}
